import {
  DealerApiCommunications,
  performInitialLoginAttempt,
  refreshUserToken,
  startTokenRefreshTimer
} from '../../webmodule-common/other/api/dealer-api-communications';
import { getCurrentUser } from '../../webmodule-common/other/api/current-user';

export async function performPageLoadLoginVerifications(updateNote: (message: string) => void) {
  //This is going to go to the api and verify the user token is valid
  //and if it is, it will also set the security roles of the user
  const valid = await DealerApiCommunications.verifyUserAndSetSecurityClaims('api/System/verifyuser');
  if (!valid) {
    await performInitialLoginAttempt('api/System/verifyuser');
    return getCurrentUser() !== null;
  } else {
    const user = await refreshUserToken(updateNote);
    if (user) {
      updateNote('Fetching User Settings');
      startTokenRefreshTimer();
      return true;
    } else return false;
  }
}

export async function dealerVerifyUser(updateNote: (message: string) => void) {
  return await performPageLoadLoginVerifications(updateNote);
}
